import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap-modal'
import { useForm } from 'react-hook-form'
import TextInput from './inputs/text-input'
import TextArea from './inputs/text-area'
import { patchForm, postForm } from '../../ajax'
import FlashAlert from '../flash-alert'

function TermForm({partnerId, data, onClose, onCreate, onUpdate}) {
  const isNew = !data.id
  const requiredMsg = 'Is required'
  const [loading, setLoading] = useState(false)
  const [alert, setAlert] = useState()
  const { register, reset, setValue, handleSubmit, formState: { errors } } = useForm()

  useEffect(() => {
    reset(_.omit(data, 'id'))
  }, [data])

  const validatePresence = (value) => {
    if (!value.trim()) return requiredMsg
  }

  const prepareFormData = (data) => {
    let formData = new FormData()
    for (const key in data) { if (data[key]) formData.append(`term[${key}]`, data[key]) }
    return formData
  }

  const submitUrl = () => {
    if (isNew) return `/admins/partners/${partnerId}/terms.json`

    return `/admins/partners/${partnerId}/terms/${data.id}.json`
  }

  const onSubmit = async (data) => {
    let formData = prepareFormData(data)
    const submitMethod = isNew ? postForm : patchForm

    setLoading(true)
    const response = await submitMethod(submitUrl(), formData)
    const json = await response.json()
    setLoading(false)
    if (json.alert)
      setAlert(json.alert)
    else {
      const term = json.term
      isNew ? onCreate(term) : onUpdate(term)
    }
  }

  return (
    <Modal dialogClassName='term-modal' backdrop='static' container={document.body} show={true} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{isNew ? 'New Terms and Conditions' : 'Edit Terms and Conditions'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} /> }
        { loading && <div className='animated-spinner'></div> }
        <form className={'term-form' + (loading ? ' isLoading' : '')} onSubmit={handleSubmit(onSubmit)}>
          <TextInput
            {...register('name', { required: 'Is required', validate: validatePresence })}
            label='Name'
            error={errors && errors.name}
            onChange={e => setValue('name', e.target.value)}
          />
          <TextArea
            {...register('text', { required: 'Is required', validate: validatePresence })}
            label='Terms text'
            error={errors && errors.text}
            onChange={e => setValue('text', e.target.value)}
          />
          <TextInput
            {...register('url', {
              pattern: {
                value: /^(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/i,
                message: 'Invalid URL'
              } 
            })}
            label='Link to full terms document/website'
            error={errors && errors.url}
            onChange={e => setValue('url', e.target.value)}
          />
          <div className='form-action'>
            <input type='submit' value={isNew ? 'Create' : 'Update'} className='btn btn-primary' />
            <button className='btn btn-default' onClick={onClose} type='button'>Cancel</button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  )
}

TermForm.propTypes = {
  partnerId: PropTypes.number.isRequired,
  data: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
}

export default TermForm
